// extracted by mini-css-extract-plugin
export var details = "_ep-0";
export var inspectorPopover = "_ep-1";